module.exports = __webpack_public_path__ + "static/img/logo.e9b6974.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo.png
// module id = KItN
// module chunks = 1